<template>
  <div>
    <fieldset class="guestrooms_fieldset" :class="{'comingSoon': $store.state.comingSoon}">
      <legend>{{ language.guestRoomLegend }}</legend>
      <div class="label" id="bookingform__rooms__label">{{ language.rooms }}</div>
      <div class="form-row form-row--wide editable" v-bind:class="{edit: editMode}">
        <div class="form-field form-field--inputlike">
			<label for="rooms" class="counter_text">
            {{ language.rooms }}
          </label>
          <div class="number_counter">
            <transition name="fade">
              <span class="minus" @click="setRooms(-1)" v-if="editMode && roomsChangeable[0]"></span>
              <span class="minus inaktive" v-if="editMode && !roomsChangeable[0]"></span>
            </transition>
            <input type="text" value="1" name="rooms" id="rooms" max="11" autocomplete="off" :readonly="!editMode" :disabled="!editMode" :aria-disabled="!editMode" v-model="rooms" @keyup="changeRooms" data-parsley-excluded="true">
            <transition name="fade">
              <span class="plus" @click="setRooms(1)" v-if="editMode && roomsChangeable[1]"></span>
              <span class="plus inaktive" v-if="editMode && !roomsChangeable[1]"></span>
            </transition>
          </div>
        </div>
        <transition name="fade">
          <a v-if="!unEditable && !!appEditLink" :href="appEditLink" role="button" class="edit-toggle" tabindex="0">{{ language.editGuestRoom }}</a>
          <a v-if="!editMode && !unEditable && !appEditLink" href="#" role="button" class="edit-toggle" @keydown.enter.prevent="enterEditMode" @click.prevent="enterEditMode">{{ language.editGuestRoom }}</a>
        </transition>
      </div>
    </fieldset>
    <fieldset class="guestrooms_fieldset" :class="{'comingSoon': $store.state.comingSoon}">
      <legend>{{ language.guestRoomLegend }}</legend>
		<div class="label" id="bookingform__guestrooms__label">{{ language.guestRooms }}</div>
		<div class="form-row form-row--wide editable" v-bind:class="{edit: editMode}">
        <a href="#" class="hidden" id="guestModalToggle" data-target="#modal10" rel="nofollow"></a>

        <div class="form-field form-field--inputlike">
			<label for="guests" class="counter_text">
            {{ language.people_widget }}
          </label>
          <div class="number_counter" data-max="2">
            <transition name="fade">
              <span class="minus" @click="setGuests(-1)" v-if="editMode && guestsChangeable[0]"></span>
              <span class="minus inaktive" v-if="editMode && !guestsChangeable[0]"></span>
            </transition>
            <input type="text" value="1" name="guests" id="guests" max="11" autocomplete="off" :readonly="!editMode" :disabled="!editMode" :aria-disabled="!editMode" v-model="guests" @keyup="changeGuests" data-parsley-excluded="true">
            <transition name="fade">
              <span class="plus" @click="setGuests(1)" v-if="editMode && guestsChangeable[1]"></span>
              <span class="plus inaktive" v-if="editMode && !guestsChangeable[1]"></span>
            </transition>
          </div>
        </div>
        <transition name="fade">
          <a v-if="!unEditable && !!appEditLink" :href="appEditLink" role="button" class="edit-toggle" tabindex="0" :aria-label="language.editGuestRoom">{{ language.editGuestRoom }}</a>
          <a v-if="!editMode && !unEditable && !appEditLink" href="#" role="button" class="edit-toggle" @keydown.enter.prevent="enterEditMode" @click.prevent="enterEditMode" :aria-label="language.editGuestRoom">{{ language.editGuestRoom }}</a>
        </transition>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'GuestRooms',

  props: {
    unEditable: Boolean
  },
  data: function () {
    return {
      dropDownOpen: false
    }
  },

  mounted: function () {
    this.roomsChangeable
    this.guestsChangeable
  },
  computed: {
    editMode: function () {
      return this.$store.state.editMode
    },
    appEditLink: function () {
      return this.$store.state.appEditLink
    },
    language: function () {
      return this.$store.state.language
    },

    citizenm: function () {
      return window.citizenm ? window.citizenm : {
        helpers: {
          show: function () {
            return
          }
        }
      }
    },

    shortHandText: function () {
      let text = this.guests + ' ' + (this.guests > 1 ? this.language.adults : this.language.adult)
      return text + ' - ' + this.rooms + ' ' + (this.rooms > 1 ? this.language.rooms : this.language.room)
    },

    rooms: {
      set(value) {
        this.$store.commit('setRooms', value)
      },
      get() {
        return this.$store.state.rooms
      }
    },
    roomsChangeable: function () {
      const stat = [true, true]

      if (this.$store.state.rooms == 1) {
        stat[0] = false
      }
      if (this.$store.state.rooms > this.$store.state.roomsMax) {
        stat[1] = false
        this.setRooms(-1)
      }

      return stat
    },
    guestsChangeable: {
      set() {
        return this.get
      },
      get() {
        const stat = [true, true]

        if (this.$store.state.guests == 1) {
          stat[0] = false
        }
        if (this.$store.state.guests >= this.$store.state.guestsMax) {
          stat[1] = false
        }

        return stat
      }
    },
    guests: {
      set(value) {
        this.$store.commit('setGuests', Math.min(parseInt(value), this.$store.state.guestsMax))
      },
      get() {
        return this.$store.state.guests
      }
    }
  },

  methods: {

    enterEditMode(e) {
      this.$emit('edit', e)
    },

    onFocus() {
      this.$emit('focus')
    },

    toggleDropdown() {
      if (this.dropDownOpen) return this.hideDropdown()
      return this.openDropdown()
    },
    openDropdown() {
      this.dropDownOpen = true
      this.$emit('opened')
    },
    hideDropdown() {
      this.dropDownOpen = false
      this.$emit('closed')
    },

    close: function () {
      return this.hideDropdown()
    },

    setRooms: function (diff) {
      const newRooms = this.$store.state.rooms + parseInt(diff)
      this.$store.commit('setRooms', Math.min(newRooms, this.$store.state.roomsMax))

      if (newRooms > this.$store.state.roomsMax) {
        // open modal
        const evt = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
        document.getElementById('guestModalToggle').dispatchEvent(evt)
      }
      this.roomsChangeable
    },
    changeRooms: function (e) {
      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowRight':
          if (this.roomsChangeable[1]) this.setRooms(1)
          break
        case 'ArrowDown':
        case 'ArrowLeft':
          if (this.roomsChangeable[0]) this.setRooms(-1)
          break
        default:
          break
      }
    },

    setGuests: function (diff) {
      const newGuests = this.$store.state.guests + parseInt(diff)
      this.$store.commit('setGuests', Math.min(newGuests, this.$store.state.guestsMax))
      this.guestsChangeable
    },

    addGuest: function () {

    },
    removeGuest: function () {

    },

    changeGuests: function (e) {
      switch (e.key) {
        case 'ArrowUp':
        case 'ArrowRight':
          if (this.guestsChangeable[1]) this.setGuests(1)
          break
        case 'ArrowDown':
        case 'ArrowLeft':
          if (this.guestsChangeable[0]) this.setGuests(-1)
          break
        default:
          break
      }
    },
  }
}
</script>